export default "__VITE_ASSET__BnIh4$u8__"